import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import batchActions from '../../../../../../actions/batch.actions';
import helper from '../../../../../../utils/helper';
import qs from 'qs';
import NewProcessPage from './NewProcessPage';
import lookupActions from '../../../../../../actions/lookup.actions';
import { generalActions } from '../../../../../../actions/general.action';

class NewProcess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      batchReport: {},
      getBatchReportError: '',
      fetchingGroups: false,
      isSubmitting: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.batch.batchReport !== prevState.batchReport) {
      state.batchReport = nextProps.batch.batchReport;
    }
    if (nextProps.batch.getBatchReportError !== prevState.getBatchReportError) {
      state.getBatchReportError = nextProps.batch.getBatchReportError;
    }
    if (nextProps.batch.loading !== prevState.loading) {
      state.loading = nextProps.batch.loading;
    }
    if (nextProps.batch.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.batch.isSubmitting;
    }
    state.errors = helper.centralizeError([
      nextProps.batch.errors,
      nextProps.lookup.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { batchId, deptId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    await this.props.batchActions
      .getSpecificBatchReport(batchId)
      .then(async () => await this.props.lookupActions.getUsers())
      .finally(() => {
        this.setState(
          { fetchingGroups: true },
          async () =>
            await this.props.lookupActions
              .getBRGroupsByDeptId(deptId)
              .finally(() => this.setState({ fetchingGroups: false })),
        );
      });
  }
  componentWillUnmount() {
    this.props.generalActions.clearData();
  }
  onCreateProcess = async (values) => {
    const batchReportId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).batchId;
    await this.props.batchActions
      .createProcess({ ...values, batchReportId })
      .then(() =>
        this.props.history.push(
          `/reports/batch-reports/edit-batch-report?batchId=${batchReportId}`,
        ),
      );
  };
  render() {
    const { batchReport } = this.state;
    const _batchReport = Object.assign({}, batchReport);
    if (Object.keys(_batchReport).length) {
      _batchReport.additionalField =
        _batchReport.additionalField || 'Additional Field';
    }
    return (
      <NewProcessPage
        {...this.state}
        batchReport={_batchReport}
        users={this.props.lookup.users}
        groups={this.props.lookup.groups}
        onCreateProcess={this.onCreateProcess}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    batch: state.batch,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    batchActions: bindActionCreators(Object.assign({}, batchActions), dispatch),
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewProcess);
